import { render, staticRenderFns } from "./IconRotateRight.vue?vue&type=template&id=13d1c240&scoped=true&"
import script from "./IconRotateRight.vue?vue&type=script&lang=js&"
export * from "./IconRotateRight.vue?vue&type=script&lang=js&"
import style0 from "./IconRotateRight.vue?vue&type=style&index=0&id=13d1c240&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d1c240",
  null
  
)

export default component.exports